import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Alert, Spinner } from 'react-bootstrap'
import axiosInstance from '../services/axiosInterceptor'
import useSchoolSettings from '../hooks/useSchoolSettings'
import OfficialDocLayout from './print/OfficialDocLayout'
import { fmtDateTHFull } from './aoShared'

// พิมพ์หนังสือรับรอง 3 แบบ: สภาพการเป็นนักเรียน / ความประพฤติ / การทำงานบุคลากร
export default function CertificatePrint() {
  const { ctId } = useParams()
  const school = useSchoolSettings()
  const [data, setData] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    axiosInstance.get(`/api/ao/certificates/${ctId}/print-data`)
      .then(res => { if (res.data.success) setData(res.data.data) })
      .catch(err => setError(err.response?.data?.message || 'โหลดข้อมูลไม่สำเร็จ'))
  }, [ctId])

  if (error) return <div className="p-4"><Alert variant="danger">{error}</Alert></div>
  if (!data) return <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>

  const issueDate = fmtDateTHFull(data.ct_issue_date || new Date())
  const classRoom = data.c_class ? `ชั้น${data.c_class}/${data.r_no}` : ''

  const body = {
    student_status: (
      <p className="doc-indent">
        หนังสือฉบับนี้ให้ไว้เพื่อรับรองว่า {data.st_name} เลขประจำตัวนักเรียน {data.st_idnumber}
        {data.st_birthdate ? ` เกิดวันที่ ${fmtDateTHFull(data.st_birthdate)}` : ''} เป็นนักเรียนของ{school.school_name}
        {classRoom ? ` กำลังศึกษาอยู่ใน${classRoom}` : ''} จริง
        {data.ct_purpose ? ` ทั้งนี้เพื่อใช้${data.ct_purpose}` : ''}
      </p>
    ),
    student_conduct: (
      <p className="doc-indent">
        หนังสือฉบับนี้ให้ไว้เพื่อรับรองว่า {data.st_name} เลขประจำตัวนักเรียน {data.st_idnumber}
        {classRoom ? ` นักเรียน${classRoom}` : ''} เป็นนักเรียนของ{school.school_name}
        เป็นผู้มีความประพฤติเรียบร้อย ปฏิบัติตนอยู่ในระเบียบวินัยของโรงเรียนด้วยดีตลอดมา
        {data.ct_purpose ? ` ทั้งนี้เพื่อใช้${data.ct_purpose}` : ''}
      </p>
    ),
    staff_employment: (
      <p className="doc-indent">
        หนังสือฉบับนี้ให้ไว้เพื่อรับรองว่า {data.t_name}
        {data.hp_position_title ? ` ตำแหน่ง${data.hp_position_title}` : ''} เป็นบุคลากรของ{school.school_name}
        {data.hp_hire_date ? ` โดยเริ่มปฏิบัติงานตั้งแต่วันที่ ${fmtDateTHFull(data.hp_hire_date)} จนถึงปัจจุบัน` : ' จนถึงปัจจุบัน'} จริง
        {data.ct_purpose ? ` ทั้งนี้เพื่อใช้${data.ct_purpose}` : ''}
      </p>
    ),
  }[data.ct_type]

  return (
    <OfficialDocLayout docNo={data.ct_full_no} title="หนังสือรับรอง" backLink="/admin-office/certificates">
      <div style={{ marginTop: 20 }}>{body}</div>
      <p className="doc-indent">ให้ไว้ ณ วันที่ {issueDate}</p>
      <div className="doc-sign" style={{ marginLeft: '40%', marginTop: 60 }}>
        <div>ลงชื่อ ................................................</div>
        <div style={{ marginTop: 6 }}>({school.principal_name || '....................................'})</div>
        <div>ผู้อำนวยการ{school.school_name}</div>
      </div>
    </OfficialDocLayout>
  )
}
